export const unionAffiliationData = {
  LWU: {
    "San Miguel Corporation": [
      "San Miguel Brewery Workers Union (SMBWU)",
      "San Miguel Foods Employees Union (SMFEU)",
    ],
    "Jollibee Foods Corp": [
      "Jollibee Workers Union (JWU)",
      "Jollibee Employees Association (JEA)",
    ],
    "SM Prime Holdings": [
      "SM Employees Union (SMEU)",
      "SM Workers Association (SMWA)",
    ],
    "PLDT Inc.": [
      "PLDT Employees Union (PEU)",
      "PLDT Supervisory Union (PSU)",
    ],
    "Globe Telecom": [
      "Globe Telecom Employees Union (GTEU)",
      "Globe Workers Association (GWA)",
    ],
    "Ayala Land": [
      "Ayala Land Employees Union (ALEU)",
      "Ayala Land Workers Union (ALWU)",
    ],
    "BDO Unibank": [
      "BDO Employees Union (BDOEU)",
      "BDO Ranking Association (BDORA)",
    ],
  },
  PPEU: {
    "Philippine Airlines": [
      "PAL Employees Association (PALEA)",
      "PAL Ground Crew Union (PGCU)",
    ],
    "Cebu Pacific": [
      "Cebu Pacific Employees Union (CPEU)",
      "Cebu Pacific Cabin Crew Union (CPCCU)",
    ],
    "Aboitiz Power": [
      "Aboitiz Power Employees Union (APEU)",
      "Aboitiz Power Labor Union (APLU)",
    ],
    Meralco: [
      "Meralco Employees Workers Association (MEWA)",
      "Meralco Supervisory Union (MSU)",
    ],
  },
};

export const flattenEmploymentOptionRows = (optionsTree = unionAffiliationData) => {
  const rows = [];

  Object.entries(optionsTree).forEach(([unionAffiliation, companies]) => {
    if (!companies || typeof companies !== "object") {
      return;
    }

    Object.entries(companies).forEach(([company, unionNames]) => {
      if (!Array.isArray(unionNames)) {
        return;
      }

      unionNames.forEach((unionName) => {
        rows.push({
          unionAffiliation,
          company,
          unionName,
        });
      });
    });
  });

  return rows;
};
